<script lang="ts">
  import ProductOfferCard from '$lib/flexible/blocks/ProductOfferCard.svelte'
  import { page } from '$app/stores';
  import { is_set_array } from '$lib/js/helpers';
  import type { TwoColProductComponent } from "$lib/js/strapi/types";
  import type { FullProduct } from '$lib/js/elasticsearch/types';
  import '$lib/css/components/rich-text.scss'
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let component: TwoColProductComponent
  let uClass = ''

	const scope = getContextScope()

  let products: FullProduct[] = $page.data.products
  let selectedProds: FullProduct[] = []
  let skus: string[] = []

  /* Prepare skus */
  if(component.two_products === false) {
    skus.push(component.product_skus)
  } else if(component.two_products === true) {
    skus = component.product_skus?.split(',')
  }

  /* Get current prods */
  if(products) {
    for(let index = 0; index < products.length; index++) {
      if(products[index] && skus.includes(products[index].sku)) {
        selectedProds.push(products[index]);
      }
    }
  }

  /* Move product to left */
  if(component.align_products === true) {
    uClass = 'product--left'
  }
</script>


{#if is_set_array(products) }
  <div class="product-cols">
    <div class="product-cols__inner">
      {#if component.two_products === false}
        <div class="product-cols__content {uClass}">
          {#if component.title}
            <h2 class="title">{component.title}</h2>
          {/if}

          {#if component.content}
            <div class="content u-rich-text">
              {@html component.content}
            </div>
          {/if}

          {#if component.link}
            <a href="/{scope}{component.link}">{component.link_text}</a>
          {/if}
        </div>
      {:else}
        <div class="product-cols__card">
          <ProductOfferCard product={selectedProds[1]} color={component?.card_color}/>
        </div>
      {/if}

      <div class="product-cols__card">
        <ProductOfferCard product={selectedProds[0]} color={component?.card_color}/>
      </div>
    </div>
  </div>
{/if}


<style lang="scss">
  .product-cols {
    &__inner {
      margin-top: 30px;
      margin-bottom: 30px;

      @media (min-width: 769px) {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    &__content,
    &__card {
      margin-bottom: 30px;

      @media (min-width: 769px) {
        width: calc(50% - 20px);
      }
    }

    &__content {
      a {
        display: inline-block;
        margin-top: 20px;
        font-size: 20px;
        color: var(--main);
        font-weight: 700;
        font-style: italic;
      }

      &.product--left {
        order: 2;
      }
    }
  }
</style>
